import {
  useState,
} from "react";

import {
  supabase,
} from "../supabaseClient";


// =========================================================
// WRONG QUESTION PROGRESS
//
// Supabase-based Wrong Question V2.
//
// Source of truth:
// question_user_progress
//
// This is separate from the legacy local-cache
// useWrongQuestions hook.
// =========================================================

export function useWrongQuestionProgress(
  session
) {

  const [
    wrongQuestionSummary,
    setWrongQuestionSummary,
  ] = useState({
    totalWrong: 0,
    activeWrong: 0,
    dueForReview: 0,
    masteredWrong: 0,
    totalIncorrectAttempts: 0,
  });


  const [
    loadingWrongQuestionSummary,
    setLoadingWrongQuestionSummary,
  ] = useState(false);


  // =======================================================
  // FETCH WRONG QUESTION SUMMARY
  // =======================================================

  const fetchWrongQuestionSummary =
    async () => {

      if (!session?.user?.id) {
        setWrongQuestionSummary({
          totalWrong: 0,
          activeWrong: 0,
          dueForReview: 0,
          masteredWrong: 0,
          totalIncorrectAttempts: 0,
        });

        return null;
      }


      setLoadingWrongQuestionSummary(
        true
      );


      try {

        const {
          data,
          error,
        } = await supabase.rpc(
          "get_wrong_question_summary"
        );


        if (error) {

          console.error(
            "FETCH WRONG QUESTION SUMMARY ERROR:",
            error
          );

          return null;
        }


        const row =
          data?.[0];


        const summary = {

          totalWrong:
            row?.total_wrong ?? 0,

          activeWrong:
            row?.active_wrong ?? 0,

          dueForReview:
            row?.due_for_review ?? 0,

          masteredWrong:
            row?.mastered_wrong ?? 0,

          totalIncorrectAttempts:
            row?.total_incorrect_attempts ??
            0,

        };


        setWrongQuestionSummary(
          summary
        );

        return summary;

      } catch (error) {

        console.error(
          "FETCH WRONG QUESTION SUMMARY UNEXPECTED ERROR:",
          error
        );

        return null;

      } finally {

        setLoadingWrongQuestionSummary(
          false
        );

      }

    };


  // =======================================================
  // RETURN
  // =======================================================

  return {

    wrongQuestionSummary,

    loadingWrongQuestionSummary,

    fetchWrongQuestionSummary,

  };
}